import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../Dialog';
import Button from '../Button';
import Table from '../Table';
import { BsFilePdf, BsFileEarmarkSpreadsheet } from 'react-icons/bs';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import exportPDF from '../Dialogs/exportPDF';

export default function LicensesFVDialog({ open, setOpen, licensesList = [], onSave, runCheckRPT }) {
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (!open) setSelectedIds([]);
  }, [open]);

  const toggleLicense = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSave = () => {
    onSave(selectedIds);
    setOpen(false);
  };

  // 🔹 Funkcja eksportu do CSV
  const exportCSV =  () => {
    const headers = ['Firma', 'NIP', 'Email', 'Telefon', 'Cena', 'Wystawiono'];
    const rows = licensesList.map(l => [
      l.shop_name ?? "-",
    l.nip ?? "-",
    l.client_email ?? "-",
    l.shop_phone ?? "-",
    l.price ? `${l.price} PLN` : "-",
    l.renewal_date ?? "-",
    ]);
    const csvContent = [headers, ...rows].map(e => e.join(';')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'licenses.csv');
  };

  const RunexportPDF = async() => {
    const todayISO = new Date().toISOString().split("T")[0];
    const rptNumber = `RPT-${todayISO}-${Math.random().toString(36).substr(2, 6).toUpperCase()}`;
    exportPDF(licensesList,todayISO,rptNumber);
    runCheckRPT();
 const listaSubscribersOrazListarenevalID = Object.values(
  licensesList.reduce((acc, { subscriber_id, renewal_id, vendorId }) => {
    if (!acc[subscriber_id]) {
      acc[subscriber_id] = {
        subscriber_id,
        vendorId,
        renewals: []
      };
    }
    if (renewal_id) {
      acc[subscriber_id].renewals.push(renewal_id);
    }
    return acc;
  }, {})
);
    console.log(listaSubscribersOrazListarenevalID);    
     const res = await fetch("https://hs2api.razamit.pl/addNewLicenseRenevExp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ data: listaSubscribersOrazListarenevalID, rptNumber: rptNumber, todayISO: todayISO }),
    });

    if (!res.ok) {
      if (res.status === 401) {
       // setErrorMessage("❌ Nieprawidłowy login lub hasło.");
      } else {
       // setErrorMessage(`⚠️ Błąd serwera (${res.status})`);
      }
     // loginError("Błąd logowania");
      return; // ⛔ nie pobieramy /me jeśli logowanie się nie udało
    }




  };


  const columns = [
    {
      field: 'select',
      headerName: '',
      width: 40,
      renderCell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectedIds.includes(row.id)}
          onChange={() => toggleLicense(row.id)}
        />
      )
    },
     {
      field: 'client',
      headerName: 'Klient',
     
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="flex flex-col">
            <span className="font-medium text-gray-900">{row.shop_name}</span>
            <span className="text-gray-400 text-xs">{row.client_email}</span>
          </div>
        );
      }
    },
    { field: 'expireDate', headerName: 'Data wygaśnięcia' },
    { field: 'invoiceAmount', headerName: 'Kwota faktury' },
    { field: 'invoiceDate', headerName: 'Data wystawienia' },
  ];

  const groupedSubscribers = Object.values(
    (Array.isArray(licensesList) ? licensesList : []).reduce((acc, row) => {
      if (!acc[row.subscriber_id]) {
        acc[row.subscriber_id] = {
          subscriber_id: row.subscriber_id,
          shop_name: row.shop_name,
          client_email: row.client_email,
          nip: row.nip,
          license_number: row.license_number,
          shop_phone: row.shop_phone,
          CompnyName: row.CompnyName,
          renewals: [],
        };
      }

      if (row.renewal_id) {
        acc[row.subscriber_id].renewals.push({
          id: row.renewal_id,
          license_id: row.license_id,
          date: row.renewal_date,
          amount: row.price,
          needFV: row.needFV,
          notes: row.notes,
        });
      }

      return acc;
    }, {})
  );
  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="500px">
      <DialogTitle>Lista faktur do wystawienia</DialogTitle>
      <DialogContent className="overflow-y-auto max-h-[70vh]">
        <div className="flex flex-col justify-end mb-4 gap-2">

           
<div className="flex justify-end gap-2">
    <p className="text-xs text-gray-500">Z chwilą eksportu wpisy w tabeli poniżej odłożą się i będą wymagać zatwierdzenia po wystawieniu faktur w systemie.</p></div>
  {licensesList.length > 0 &&
  <div className="flex justify-end gap-2">
          <Button
            size="small"
            variant="outlined"
            icon={<BsFilePdf />}
            onClick={RunexportPDF}
          >
            Eksport PDF
          </Button>
          
          <Button
            size="small"
            variant="outlined"
            icon={<BsFileEarmarkSpreadsheet />}
            onClick={exportCSV}
          >
            Eksport CSV
          </Button>
</div>}
        </div>
        <div className="overflow-x-auto">
            {groupedSubscribers.length === 0 ? (
          <p className="text-xs text-gray-500">Brak danych do wyświetlenia.</p>
        ) : (
         groupedSubscribers.map(sub => (
<div
  key={sub.subscriber_id}
  className="bg-white border border-slate-200 rounded-sm hover:shadow-md hover:border-primary-500 transition-all duration-200 mb-3"
>
  <div className="p-4 space-y-3">
    {/* HEADER */}
    <div className="flex justify-between items-start">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm md:text-base font-semibold text-slate-900">
          {sub.shop_name}
        </h3>

        <div className="flex flex-wrap items-center gap-3 text-xs bg-slate-50 px-3 py-2 rounded-md border border-slate-100">
          <div className="flex items-center gap-1">
            <span className="text-slate-400 font-medium">Email:</span>
            <span className="text-slate-800 font-semibold">{sub.client_email}</span>
          </div>

          <div className="w-px h-4 bg-slate-300" />

          <div className="flex items-center gap-1">
            <span className="text-slate-400 font-medium">Licencja:</span>
            <span className="text-slate-800 font-semibold">{sub.license_number}</span>
          </div>
        </div>
      </div>

      <div className="text-[11px] uppercase tracking-wide text-slate-400 bg-slate-100 px-2 py-1 rounded-md h-fit">
        ID: {sub.subscriber_id}
      </div>
    </div>

    {/* RENEWALS */}
    <div className="divide-y divide-slate-200 border-t border-slate-100">
      {sub.renewals.length === 0 ? (
        <div className="text-center py-6 text-slate-300 text-sm italic">
          Brak dostęnych pozycji
        </div>
      ) : (
        sub.renewals.map((r) => (
          <div
            key={r.id}
            className="flex items-center justify-between py-2 hover:bg-slate-50 transition"
          >
            <div className="flex flex-col">
              <p className="text-sm text-slate-900 font-medium">{r.notes}</p>
              <p className="text-xs text-slate-500">{r.date}</p>
            </div>

            <div className="text-right">
              <p className="text-sm font-semibold text-slate-800">
                {r.amount}
                <span className="text-xs text-slate-500 ml-1">PLN</span>
              </p>
            </div>
          </div>
        ))
      )}
    </div>
  </div>
</div>

))
        )}
          {/* <Table columns={columns} data={licensesList} /> */}
        </div>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={() => setOpen(false)}>
          Anuluj
        </Button>
      
      </DialogActions>
    </Dialog>
  );
}
